import { AnalysisType } from '../data-access/types/analysis-type';
import { Sample } from '../data-access/types/sampling';

export const flattenSamples = (samples: Sample[]) => {
  return samples
    .map((sample) =>
      sample.points.features.map((f) => ({
        ...f,
        properties: {
          ...f.properties,
          label: `${sample.zone}.${f.properties.zone}`,
          radius:
            f.properties.analysis_type === AnalysisType.CARBON ? '50%' : '25%',
          color:
            f.properties.analysis_type === AnalysisType.CARBON
              ? 'pf-green.9'
              : 'blue.9',
          sampleId: sample.id, // Add sample ID to identify points from the same sample
        },
      })),
    )
    .flat();
};
